<template>
  <div>
    <div class="contents event">
      <b-form @submit="onSubmit">
        <div class="filter-box-4">
          <div class="select">
            <select
              aria-label="Select Mini Game Type"
              name="type"
              v-model="searchData.status_cd"
            >
              <option value="-1">{{ $t("filter.common.total") }}</option>
              <option value="0">{{ $t("text.common.ready") }}</option>
              <option value="1">{{ $t("text.common.playing") }}</option>
              <option value="2">{{ $t("text.common.completed") }}</option>
            </select>
          </div>
          <!-- <div class="mb-0">
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div> -->
          <div class="select">
            <select class="form-select-lg" v-model="searchData.type">
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">{{ $t("filter.event.holeinone") }}</option>
              <option value="2">{{ $t("filter.event.albatross") }}</option>
              <option value="3">{{ $t("filter.event.eagle_p5") }}</option>
              <option value="4">{{ $t("filter.event.birdie_p5") }}</option>
              <option value="5">{{ $t("filter.event.par_p5") }}</option>
              <option value="6">{{ $t("filter.event.eagle_p4") }}</option>
              <option value="7">{{ $t("filter.event.birdie_p4") }}</option>
              <option value="8">{{ $t("filter.event.par_p4") }}</option>
              <option value="9">{{ $t("filter.event.longest") }}</option>
              <option value="10">{{ $t("filter.event.nearpin") }}</option>
              <option value="11">{{ $t("filter.event.longest_rank") }}</option>
              <option value="12">{{ $t("filter.event.nearpin_rank") }}</option>
            </select>
          </div>
          <div class="select">
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">
                {{ $t("filter.common.title") }}
              </option>
              <option value="2">
                {{ $t("filter.common.course") }}
              </option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxxl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th> -->
            <th class="col-auto">{{ $t("title.common.title") }}</th>
            <th class="d-none d-none d-md-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <!--             <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.type") }}
            </th> -->
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.prizes") }}
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.entry_limit") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.event.drop") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td> -->
              <td class="col-auto text-start">
                <!-- <span class="badge minigame-type">
                  {{ item.awardtype | awardtype }}
                </span> -->
                <span class="badge minigame-event-type">
                  {{ event_type(item.type) }}
                </span> 
                <p class="minigame-title">{{ item.title }}</p>
              </td>
              <!-- <td class="d-none d-md-table-cell text-date">
                {{ item.timezone_startdate | dateformat }}
                ~
                {{ item.timezone_enddate | dateformat }}
              </td> -->
              <td class="col-auto d-none d-md-table-cell text-date">
                <!-- 서비스 시간 -->
                {{ item.timezone_startdate | dateformat }}
                ~
                {{ item.timezone_enddate | dateformat }}
              </td>
              <!--               <td class="col-auto d-none d-lg-table-cell">
                {{ event_type(item.type) }}
              </td> -->
              <td class="d-none d-xxxl-table-cell">
                {{ item.coursename }} {{ item.subcoursename }}({{ item.hole }}H)
              </td>
              <td class="d-none d-xxxl-table-cell text-prize">
                {{ item.type < 11 ? null || item.point : "Rank Prize" }}
              </td>
              <td class="d-none d-xxxl-table-cell text-red">
                {{ item.entrylimit | transToValue("∞") }}
              </td>
              <td class="d-none d-xl-table-cell">
                {{ event_status(item.status) }}
              </td>
              <td class="d-none d-xxxl-table-cell">
                {{ drop_flag(item.deleteflag) }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                <button
                  type="button"
                  v-if="item.type > 10"
                  class="btn btn-primary btn-xs"
                  @click="
                    $router.push({
                      name: 'MiniGameRank',
                      params: { eventno: item.eventno },
                    })
                  "
                >
                  {{ $t("button.common.ranking") }}
                </button>
                <button
                  type="button"
                  v-else
                  class="btn btn-primary btn-xs"
                  @click="
                    $router.push({
                      name: 'WinningDetailList',
                      params: { eventno: item.eventno },
                    })
                  "
                >
                  {{ $t("button.common.view") }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-xs"
                  @click="
                    $router.push({
                      name: 'MiniGameModify',
                      params: { eventno: item.eventno },
                    })
                  "
                >
                  {{ $t("button.common.edit") }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-xs text-white"
                  @click="set_admineventdelete(item.eventno, item.deleteflag)"
                >
                  {{ $t("button.common.delete") }}
                </button>
                <button
                  type="button"
                  class="btn btn-success btn-xs text-white"
                  @click="reprocess(item.eventno)"
                >
                  {{ $t("button.common.reprocessing") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="8">
                <div class="toggle-content">
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div> -->
                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      <p>
                        <!-- 서비스 시간 -->

                        {{ item.timezone_startdate | dateformat }}
                        ~
                        {{ item.timezone_enddate | dateformat }}
                      </p>
                    </div>
                  </div>
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.common.type") }}</div>
                    <div class="col-8">{{ event_type(item.type) }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">
                      {{ item.coursename }} {{ item.subcoursename }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.hole") }}</div>
                    <div class="col-8">{{ item.hole }}H</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.prizes") }}
                    </div>
                    <div class="col-8 text-prize">
                      {{ item.type < 11 ? null || item.point : "Rank Prize" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.entry_limit") }}
                    </div>
                    <div class="col-8 text-red">
                      {{ item.entrylimit | transToValue("∞") }}
                    </div>
                  </div>
                  <div class="row d-xl-none">
                    <div class="col-4">{{ $t("title.common.status") }}</div>
                    <div class="col-8">
                      {{ event_status(item.status) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.event.drop") }}</div>
                    <div class="col-8">{{ drop_flag(item.deleteflag) }}</div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.common.control") }}</div>
                    <div class="col-8">
                      <div class="d-flex flex-column align-items-start">
                        <button
                          type="button"
                          v-if="item.type > 10"
                          class="btn btn-primary btn-xs"
                          @click="
                            $router.push({
                              name: 'MiniGameRank',
                              params: {
                                params: { eventno: item.eventno },
                              },
                            })
                          "
                        >
                          {{ $t("button.common.ranking") }}
                        </button>
                        <button
                          type="button"
                          v-else
                          class="btn btn-primary btn-xs"
                          @click="
                            $router.push({
                              name: 'WinningDetailList',
                              params: { eventno: item.eventno },
                            })
                          "
                        >
                          {{ $t("button.common.view") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary btn-xs"
                          @click="
                            $router.push({
                              name: 'MiniGameModify',
                              params: { eventno: item.eventno },
                            })
                          "
                        >
                          {{ $t("button.common.edit") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger btn-xs text-white"
                          @click="
                            set_admineventdelete(item.eventno, item.deleteflag)
                          "
                        >
                          {{ $t("button.common.delete") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success btn-xs text-white"
                          @click="reprocess(item.eventno)"
                        >
                          {{ $t("button.common.reprocessing") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'MiniGameWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/event";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MiniGameList",
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        type:
          this.$route.query.type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].type) ||
          0,
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        status_cd:
          this.$route.query.status_cd ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status_cd) ||
          "-1",
      },

      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_admineventlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_admineventlist();
    },
    "searchData.type": function () {
      this.searchData.pageno = 1;
      this.get_admineventlist();
    },
    "searchData.status_cd": function () {
      this.searchData.pageno = 1;
      this.get_admineventlist();
    },
    "searchData.pageno": function () {
      this.get_admineventlist();
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admineventlist();
    },
    get_admineventlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_admineventlist(this.searchData, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          if (data.eventlistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.eventlistcnt;
          this.page_total = Math.ceil(data.eventlistcnt / this.rows);
          this.items = data.eventlist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    reprocess(rule_pk) {
      if (confirm(this.$i18n.t("text.common.reprocess_txt"))) {
        ax.set_reprocess(rule_pk, (flag, data) => {
          alert(data.message);
          this.$bvModal.hide("modal-correction");
          if (flag) {
            if (data.code === 200) {
              this.get_admineventlist();
            }
          } else {
            return false;
          }
        });
      }
    },
    set_admineventdelete(eventno, deleteflag) {
      ax.set_admineventdelete(eventno, (flag, data) => {
        if (flag) {
          alert(data.message);
          this.get_admineventlist();
        } else {
          alert(data.message);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_admineventlist();
  },
  mixins: [myMixin],
};
</script>
